export default __webpack_public_path__ + "static/media/aiainaiLogo.9f858d8b.png";